import * as React from 'react';
import { motion } from 'motion/react';

// Animation for highlighted (optional) forms that can enter the screen
const HighlightedForm = ({ children , className ,  })=>/*#__PURE__*/ React.createElement(motion.div, {
        className: className,
        initial: "exit",
        animate: "enter",
        exit: "exit",
        variants: {
            enter: {
                height: 'auto',
                opacity: 1,
                transition: {
                    ease: 'easeOut',
                    duration: 0.25
                }
            },
            exit: {
                height: '1px',
                opacity: 0,
                transition: {
                    ease: 'easeIn',
                    duration: 0.15
                }
            }
        }
    }, children)
;

export { HighlightedForm };
//# sourceMappingURL=HighlightedForm.js.map
